import clsx from 'clsx';
import Structure from '../Structure';
import { ColumnaProps } from './Columna.types';
import styles from './columna.module.scss';

export default function Columna(props: Readonly<ColumnaProps>) {
    const { columnes, tipus, estil, className } = props;
    const columnClass = 'col' + columnes;

    const styleColumn = clsx(styles[columnClass], tipus && styles[tipus], estil && styles[estil], className);

    return (
        <div className={styleColumn}>
            <Structure {...props} />
        </div>
    );
}
